import { getHeaderHeight } from 'utils/bolt/index';

export function getSectionScrollOffset() {
	return getHeaderHeight();
}